function importAll(r) {
    return r.keys().map(r);
}

const images = importAll(
    require.context("./01_images", false, /\.jpg$/)
);

const caption = [
    //LESSON 1
    "Особлива пропозиція - знижка до 60%",
    "Заходьте, відкрито, вибачте, закрито",
    "Розпродаж, знижка до 50%",
    "Вхід. Вихід",
    "Тільки картки, без готівки",
    //LESSON 2
    "У цій зоні заборонено вживати їжу та напої",
    "Люблю дні, коли це моя єдина проблема",
    "Тиха зона, не турбувати",
    "Оголошення — Будь ласка, вимикайте світло, коли не користуєтеся",
    "Будь ласка, приберіть за собою, служниця у відпустці",
    //LESSON 3
    "Креативний куточок: олівці, фломастери, скотч",
    "Місце для читання - Будь ласка, дбайте про книжки",
    "Давай зробимо щось веселе",
    "Час зустрітится з музикою",
    "Шиття — моя щаслива година",
    //LESSON 4
    "Відправлення Прибуття Багаж Реєстрація Трансфер",
    "Вихід • Видача багажу • Служба підтримки клієнтів ",
    "Усі інші паспорти • Прискорений прохід • Паспорти ЄС/Великої Британії • Кордон Великої Британії",
    "Пункт призначення • Хвилини • Платформа • Схема руху",
    "Оголошення з безпеки — Вийміть усе з кишень перед проходженням через детектори.",
    //LESSON 5
    "Зберігаємо спокій та готуємо разом!",
    "Цю кухню слід підтримувати в чистоті та порядку",
    "Здорове серце потребує здорової їжі та фізичної активності",
    "Кондитерська — Усе спечено сьогодні",
    "Зона приготування їжі — Лише для овочів",
    //LESSON 6
    "Час, проведений із родиною, вартий кожної секунди",
    "Правила ігрової кімнати — Будь добрим, Ділись, Веселись",
    "Живи повноцінно, Люби щиро, Смійся часто",
    "Щастя — це... дзвінок від близьких",
    "Новий дім, новий початок, нові спогади",
    //LESSON 7
    "Читання дарує нам місце, куди можна вирушити, навіть коли ми змушені залишатися на місці",
    "Не говори зі мною — у мене немає сили волі, я проговорю з тобою годинами й нічого не зроблю",
    "Візьми чашечку чаю — опануй нову навичку сьогодні",
    "Будь відповідальним. Будь ввічливим. Будь готовим до навчання",
    "Використання особистих мобільних пристроїв під час занять більше не дозволяється",
    //LESSON 8
    "Ставте речі на їхні місця",
    "Години роботи: понеділок–п’ятниця 8:00–17:00, субота–неділя — за домовленістю",
    "Безпека починається з командної роботи",
    "Думайте про чистоту. Ця кімната для вашої зручності. Будь ласка, підтримуйте її в чистоті",
    "Мрій масштабно, став цілі, дій",
    //LESSON 9
    "Будь ласка, перевіряйте ціну перед замовленням їжі та напоїв",
    "Заощаджуйте сьогодні — ваші гроші врятують вас завтра",
    "Повторне використання. Скорочення. Переробка",
    "Увага! Оплата лише банківською карткою або безконтактним способом. Тільки сьогодні",
    "Зберігайте чек — без чека повернення або обміну немає",
    //LESSON 10
    "Школа не несе відповідальності за втрату будь-яких пристроїв, які ваша дитина приносить до школи",
    "Думай, перш ніж щось публікувати — це правда, корисно, надихає, необхідно, доброзичливо?",
    "Поради щодо балансу між онлайн- і офлайн-часом",
    "Онлайн-безпека: не спілкуйтесь із незнайомцями, особливо в інтернеті",
    "Яким цифровим громадянином є ти?",
    //LESSON 11
    "Будь ласка, вимкніть звук на своїх телефонах",
    "Увага, використання спалаху заборонено",
    "Дивіться фільми безкоштовно",
    "Ласкаво просимо на кіновечір",
    "У тренді зараз",
    //LESSON 12
    "Жива музика сьогодні ввечері",
    "Службовий вхід — тільки для гурту та персоналу",
    "Караоке-вечір: веселощі гарантовано, талант — ні",
    "Б’юсь об заклад, ти виглядаєш чудово на танцполі",
    "Зйомка відео за цією межею заборонена",

    //LESSON 13
    "Фітнес-центр відкритий щодня, для входу використовуйте картку від номера",
    "Санітарна станція. Будь ласка, протирайте обладнання після використання",
    "Шиповане взуття на біговій доріжці заборонене",
    "Поле закрите на обслуговування",
    "Йога триває. Будь ласка, не турбувати",

    //LESSON 14
    "Наживо — Гарячі новини",
    "Будь ласка, зареєструйтесь у рецепції",
    "Інформація про погоду — налаштуйте радіо на FM",
    "Щоденний брифінг у п’ятницю",
    "Не турбувати, триває інтерв’ю",

    //LESSON 15
    "Твоє майбутнє починається тут",
    "Мрій. Вір. Досягай",
    "Дорога до успіху на стадії будівництва",
    "Якщо не спробуєш — не дізнаєшся",
    "Правила: 1) будь добрим 2) працюй старанно 3) будь скромним 4) частіше усміхайся",

    //LESSON 16
    "У різноманітті — краса і сила",
    "Молитовна кімната для всіх віросповідань",
    "Поважай себе, інших і місце, де перебуваєш",
    "Образлива мова не допускається. Порушників попросять залишити приміщення",
    "Ми бачимо речі не такими, якими вони є, а такими, якими є ми самі",

    //LESSON 17
    "Сьогоднішня погода... хмарно, буря, сніг, вітряно, сонячно, дощ, туман. Морозно, холодно, помірно, тепло, спекотно",
    "Попередження: зимові погодні умови",
    "Весна — час розквітати і зростати",
    "Парасольки заборонені. Залиште парасольку тут",
    "Перевірте погоду. Вправа на уважність",

    //LESSON 18
    "Зона без стресу. Розслабся і насолоджуйся",
    "Піклуйся про своє психічне здоров’я. Звертай увагу на попереджувальні знаки",
    "Будь у безпеці та здоровим",
    "Самодопомога — це не егоїзм",
    "Ходіть 1000 кроків щодня",

    //LESSON 19
    "Твоя історія має значення",
    "Ми не пам’ятаємо днів, ми пам’ятаємо моменти",
    "Слухай вухами, очима й серцем",
    "Як написати особисте есе",
    "Кожна історія має значення",

    //LESSON 20
    "Куди б ти подорожував, якби міг поїхати будь-куди у світі?",
    "Якби ти міг змінити щось одне у своєму житті, що б це було?",
    "Якби ти міг повернутись у минуле, яку епоху ти б обрав?",
    "Якби ти міг описати свій майбутній дім трьома словами, якими б вони були?",
    "Якби ти міг мати лише одну суперсилу, яку б ти обрав?",

    //LESSON 21
    "Загубись у хорошій книжці",
    "Будь ласка, повертайте книги після використання",
    "Думай, перш ніж говорити. Читай, перш ніж думати",
    "Читання робить твій світ ширшим",
    "Ласкаво просимо до бібліотеки самообслуговування. Візьми книжку — залиш книжку",

    //LESSON 22
    "Візьми друга з притулку — не купуй. Почни дружбу на все життя",
    "Усі гості мають бути схвалені котом",
    "Обережно: собаки. Не заходьте — вони швидші за вас",
    "Sniff and Bark — магазин для собак",
    "Любов — це вологі носики і хвости, що виляють",

    //LESSON 23
    "Скорочуй, використовуй повторно, переробляй і поважай",
    "Природі не потрібні люди. Людям потрібна природа",
    "Будь ласка, не сходьте з маршруту — це ваша безпека і захист довкілля",
    "Дбай про дику природу — кермуй обережно",
    "Зона чистого повітря Брістоля. Звертай увагу на знаки при наближенні або в’їзді в зону",

    //LESSON 24
    "Ласкаво просимо до нашого району",
    "Це зона наглядового сусідства",
    "Розваги для всієї родини. Фестиваль на головній вулиці. Дитяча зона",
    "Дякуємо, що купуєте у місцевих",
    "Серце спільноти. Купуй. Ділись. Разом",

    //LESSON 25
    "Говори доброзичливо — слова мають значення!",
    "Спілкування — це більше, ніж слова",
    "Мати ще одну мову — це володіти другою душею",
    "Поезія — це те, що губиться в перекладі",
    "Найважливіше в спілкуванні — чути те, що не сказано",

    //LESSON 26
    "Життя занадто коротке, щоб носити нудний одяг",
    "Стиль — це спосіб сказати, хто ти, без слів",
    "Одягайся так, як хочеш, щоб до тебе зверталися",
    "Моя філософія стилю — це комфорт",
    "Примірочна",

    //LESSON 27
    "Нехай свято розпочнеться",
    "Радість і хороша енергія — заразні",
    "Гаряча та холодна їжа і напої через 5 миль",
    "Танцюй, наче ніхто не дивиться",
    "За всі гарні спогади — тост!",

    //LESSON 28
    "Твори без страху",
    "Кожен митець колись був аматором",
    "Ніяких правил, ніяких обмежень — тільки мистецтво",
    "Мистецтво говорить там, де слова безсилі",
    "Створи своє бачення",

    //LESSON 29
    "Пішохідний перехід",
    "Паркуйся та їдь",
    "Велосипедисти, слідкуйте за транспортом, що повертає",
    "Повільно — шкільна зона попереду",
    "Смуга тільки для автобусів",

    //LESSON 30
    "Кожен виклик — це можливість для зростання",
    "Успіх заробляється, а не дарується",
    "Маленькі кроки сьогодні — великі перемоги завтра",
    "Єдина межа — це ти сам",
    "Помилки — це доказ того, що ти намагаєшся",

]

export const ReadingSignsData = images.map((image, index) => (
    {
        id: index + 1,
        lesson: Math.floor(index / 5) + 1,
        image,
        caption: caption[index],
        visibility: "hidden",
    }
))



